import { themes } from ".";

export const formKeyText = {
  fontSize: { xs: 15, sm: 15, md: 15, lg: 18, xl: 18 },
  fontWeight: "bold",
  color: themes.headLine,
  textAlign: {
    xs: "center",
    sm: "center",
    md: "center",
    lg: "right",
    xl: "right",
  },
  paddingRight: 4,
  paddingTop: 1.5,
};

export const formKeyDisabledText = {
  fontSize: { xs: 15, sm: 15, md: 15, lg: 18, xl: 18 },
  fontWeight: "bold",
  color: themes.disable,
  textAlign: {
    xs: "center",
    sm: "center",
    md: "center",
    lg: "right",
    xl: "right",
  },
  paddingRight: 4,
  paddingTop: 1.5,
};

export const formKeyTextRight = {
  fontSize: { xs: 15, sm: 15, md: 17, lg: 18, xl: 18 },
  fontWeight: "bold",
  color: themes.headLine,
  textAlign: {
    xs: "center",
    sm: "center",
    md: "center",
    lg: "left",
    xl: "left",
  },
  paddingRight: 4,
  paddingTop: 1.5,
};

export const formKeyTextRightUd = {
  fontSize: { xs: 15, sm: 15, md: 17, lg: 18, xl: 18 },
  fontWeight: "bold",
  color: themes.headLine,
  textAlign: {
    xs: "center",
    sm: "center",
    md: "center",
    lg: "left",
    xl: "left",
  },
  paddingLeft: 20,
};

export const formText = {
  fontSize: { xs: 15, sm: 15, md: 17, lg: 18, xl: 18 },
  fontWeight: "bold",
  color: themes.headLine,
  textAlign: {
    xs: "center",
    sm: "center",
    md: "center",
    lg: "right",
    xl: "right",
  },
  mt: 2,
  mr: 2.5,
};

export const alignCenterItems = {
  borderRight: `1px solid ${themes.sidebarDivider}`,
  padding: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
};

export const formRightSideAlign = {
  display: "flex",
  justifyContent: {
    xs: "center",
    sm: "center",
    md: "center",
    lg: "left",
    xl: "left",
  },
  alignItems: "center",
};

export const formHeader = {
  fontSize: { xs: 17, sm: 17, md: 20, lg: 24, xl: 24 },
  fontWeight: "bold",
  color: themes.headLine,
};

export const formBackGroundColor = "#F2F2F7";

export const tableContainerSx = {
  padding: 1,
  width: "100%",
  maxHeight: { xs: 150, sm: 300, md: 400, lg: 700, xl: 750 },
};

export const tableContainerSxWithCompany = {
  padding: 1,
  width: "100%",
  maxHeight: { xs: 150, sm: 300, md: 400, lg: 650, xl: 700 },
};

export const tableHeaderSx = {
  backgroundColor: themes.primary,
  position: "sticky",
  top: -1,
  zIndex: 10,
};

export const tableRowSxWithIcons = {
  "& .MuiTableCell-root": {
    height: "10px",
    padding: "3px 15px",
  },
};

export const tableRowSxWithOutIcons = {
  "& .MuiTableCell-root": {
    height: "10px",
    padding: "3px 15px",
  },
};

export const border = `2px solid ${themes.sidebarDivider}`;
export const tableCellFontSize = { xs: 6, sm: 8, md: 10, lg: 12, xl: 15 };

export const scrollTop = (tableContainerRef) => {
  if (tableContainerRef.current) {
    tableContainerRef.current.scrollTop = 0;
  }
};

export const tableData = { color: themes.headLine, fontWeight: "bold" };

export const attendanceStatusBox = {
  width: "28px",
  height: "28px",
  textAlign: "center",
  lineHeight: "29px",
};

export const attendanceStatusHalfBox = {
  width: "14px",
  height: "28px",
  textAlign: "center",
  lineHeight: "29px",
};

export const rowEndStyle = {
  display: "flex",
  flexDirection: "row",
  justifyContent: "flex-end",
  alignItems: "flex-end",
};

export const formKeyTextRightWithSmallScreenLeft = {
  fontSize: { xs: 15, sm: 15, md: 15, lg: 15, xl: 18 },
  fontWeight: "bold",
  color: themes.headLine,
  textAlign: {
    xs: "left",
    sm: "left",
    md: "left",
    lg: "left",
    xl: "left",
  },
  paddingRight: 4,
  paddingTop: 1.5,
};

//Tooltip

export const tooltipStyleProps = {
  tooltip: {
    sx: {
      color: themes.whiteColor,
      fontSize: "14px",
      backgroundColor: themes.darkBlue,
      borderRadius: "10px", // Set desired font size here
    },
  },
  arrow: {
    sx: {
      color: themes.darkBlue,
    },
  },
};
